// extracted by mini-css-extract-plugin
export default {"Column":"Column_Column__-vkMQ","BottomOffset":"Column_BottomOffset__e2F53"};